import React from 'react';
import { Link } from 'react-router-dom';
import './FeaturedImage.css';

const FeaturedImage = () => {
  return (
    <section className="featured-image-section w-screen">
      <Link to="/laptops" className="featured-image-link">
        <div className="featured-image-container">
          <picture>
            <source media="(max-width: 768px)" srcSet="/images/home-mobile.webp" />
            <img
              src="/images/home.webp"
              alt="Featured Content"
              className="absolute left-0 top-0 w-full h-full object-cover"
            />
          </picture>
        </div>
      </Link>
    </section>
  );
};

export default FeaturedImage;
